import baseAPI from '@/api/base';
import { EditScreenArtboard, GetScreenArtboard, RegisterScreenArtboard } from '@/dtos/screen_artboard.dto';
import {
  DELETE_SCREEN_ARTBOARD_URL,
  EDIT_SCREEN_ARTBOARD_URL,
  GET_SCREEN_ARTBOARD_CONTENT_URL,
  GET_SCREEN_ARTBOARD_URL,
  REGISTER_SCREEN_ARTBOARD_URL,
  TOGGLE_SCREEN_ARTBOARD_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class ScreenArtboard {
  static getScreenArtboards = async (getScreenArtboard: GetScreenArtboard): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_SCREEN_ARTBOARD_URL, {
      params: getScreenArtboard,
    });
    console.log('response', response);
    return response;
  };

  static getScreenArtboardContent = async (getScreenArtboard: GetScreenArtboard): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_SCREEN_ARTBOARD_CONTENT_URL, {
      params: getScreenArtboard,
    });
    console.log('response', response);
    return response;
  };

 static registerScreenArtboard = async (
    registerScreenArtboard: RegisterScreenArtboard
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_SCREEN_ARTBOARD_URL,
      {
        ...registerScreenArtboard,
      }
    );
    console.log('response', response);
    return response;
  };

  static editScreenArtboard = async (
    editScreenArtboard: EditScreenArtboard
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_SCREEN_ARTBOARD_URL,
      {
        ...editScreenArtboard,
      }
    );
    return response;
  };

  static toggleScreenArtboardIsActive = async (
    editScreenArtboard: EditScreenArtboard
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_SCREEN_ARTBOARD_IS_ACTIVE_URL,
      {
        ...editScreenArtboard,
      }
    );
    return response;
  };

  static deleteScreenArtboard = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_SCREEN_ARTBOARD_URL}/${userId}`
    );
    return response;
  };
}

export default ScreenArtboard;
